import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { messages } from '@/lang/translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'es',
  messages
});

const specialBus = new Vue({
  i18n
})

export const roles = ['superuser', 'accountmanager', 'finance', 'viewer', 'user', 'editorgames'];

export const providers = [
  {
    text: 'Opta',
    value: 'opta',
  },
  {
    text: 'Sportsdata',
    value: 'sportsdata',
  },
  {
    text: 'Mobadoo',
    value: 'mobadoo',
  },
];

export const sports = (locale) => {
  specialBus.$i18n.locale = locale
  return [
    {
      text: specialBus.$t('back.sport.soccer'),
      value: 'soccer'
    },
    {
      text: specialBus.$t('back.sport.basket'),
      value: 'basket'
    },
    {
      text: specialBus.$t('back.sport.csgo'),
      value: 'csgo'
    },
    {
      text: specialBus.$t('back.sport.lol'),
      value: 'lol'
    },
  ];
};

export const payout = ['WINNER','TOP3','X2','X3','X5','MATRIX','MUTUAL'];

export const poolType = ['NORMAL', 'JACKPOT', 'ENDSEASON'];

export const championshipFormat = ['seven','five','eleven'];

export const gameType = ['SLOT', 'POOL', 'ROULETTE', 'BLACKJACK', 'INSTANT', 'SCRATCH', 'POKER', 'BINGO', 'VIRTUAL', 'TABLE', 'OTHER'];

export const jurisdictions = [
  {
    text:'Bahamas',
    value:'BS'
  },
  {
    text:'Bulgaria',
    value:'BG'
  },
  {
    text:'Denmark',
    value:'DK'
  },
  {
    text:'United Kingdom',
    value:'UK'
  },
  {
    text:'Italy',
    value:'IT'
  },
  {
    text:'Spain',
    value:'ES'
  },
  {
    text:'Portugal',
    value:'PT'
  },
  {
    text:'Romania',
    value:'RO'
  },
  {
    text:'Malta',
    value:'MT'
  },
  {
    text:'Philippines',
    value:'PH'
  },
  {
    text:'Lithuania',
    value:'LT'
  },
  {
    text:'Latvia',
    value:'LV'
  },
  {
    text:'Estonia',
    value:'EE'
  },
  {
    text:'Sweden',
    value:'SE'
  },
  {
    text:'Colombia',
    value:'CO'
  },
  {
    text:'Guernsey (Alderney)',
    value:'GG'
  },
  {
    text:'Unregulated market',
    value:'99'
  },
];

export const lobbyCountries = [
  {
    text:'Spanish',
    value:'ES'
  },
  {
    text:'English',
    value:'EN'
  },
  {
    text:'Portuguese',
    value:'PT'
  },
];

export const licenses = [
  {
    text:'Slots',
    value:'AZA'
  },
  {
    text:'Sportsbook',
    value:'ADC'
  },
  {
    text:'Sportsbook e-Sports',
    value:'OAC'
  },
  {
    text:'Blackjack',
    value:'BLJ'
  },
  {
    text:'Roulette',
    value:'RLT'
  },
  {
    text:'Mutuas',
    value:'ADM'
  },
  {
    text:'Pocker Cash',
    value:'POC'
  },
  {
    text:'Pocker Torneo',
    value:'POT'
  },
  {
    text:'Casino',
    value:'CAS'
  },
];

export const connectors = [
  {
    text: 'Tecnalis',
    value: 'TECNALIS'
  },
  {
    text: 'Emara',
    value: 'EMARA'
  },
  {
    text: 'Optima',
    value: 'OPTIMA'
  },
  {
    text: 'BtoBet',
    value: 'BTOBET'
  },
  {
    text: 'VivoGaming',
    value: 'VIVO'
  },
  {
    text: 'Gaming1',
    value: 'GAMING1'
  }
];

export const currencyList = [
  { text: '€', value: 'EUR' },    // Europa
  { text: 'ARS$', value: 'ARS' }, // Argentina
  { text: '$b', value: 'BOB' },   // Bolivia
  { text: 'BOV', value: 'BOV' },  // Bolivia
  { text: 'R$', value: 'BRL' },   // Brasil
  { text: 'CA$', value: 'CAD' },  // Canada
  { text: 'CLF', value: 'CLF' },  // Chile
  { text: 'CLP$', value: 'CLP' }, // Chile
  { text: 'COP$', value: 'COP' }, // Colombia
  { text: 'COU', value: 'COU' },  // Colombia
  { text: 'G$', value: 'GYD' },   // Guyana
  { text: 'MXN', value: 'MXN' },   // Guyana
  { text: 'PYD', value: 'PYD' },  // Paraguay
  { text: 'S/.', value: 'PEN' },  // Perú
  { text: 'TT$', value: 'TTD' },  // Trinidad y Tobago
  { text: '$', value: 'USD' },    // Estados Unidos, Ecuador
  { text: 'UYI', value: 'UYI' },  // Uruguay
  { text: '$U', value: 'UYU' },   // Uruguay
  { text: 'UYW', value: 'UYW' },  // Uruguay
  { text: 'SRD$', value: 'SRD' }, // Surinam
  { text: 'VES', value: 'VES' }, // Surinam
  { text: 'FUN', value: 'FUN' },  // Fun
];

export const freespinsQuantityList = [
  '0.1',
  '0.15',
  '0.2',
  '0.25',
  '0.3',
  '0.35',
  '0.4',
  '0.45',
  '0.5',
  '0.6',
  '0.7',
  '0.8',
  '0.9',
  '1',
  '1.5',
  '2',
  '2.5',
  '3',
  '3.5',
  '4',
  '4.5',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '60',
  '70',
  '80',
  '90',
  '100',
];
